import { ONE_DAYS_IN_UTC_FORMAT } from 'app/containers/contexts/menuDates.consts';
import { menuDatesState } from 'app/containers/contexts/menuDates.context';
import React, { useContext, useMemo } from 'react';

export const useDisabledDatesSelected = () => {
    const { state: { dateFilterStatus, selectedPeriodIndex } } = useContext(menuDatesState);

    const isDisabledDateSelected = useMemo(() => {
        const isInFirstPeriod = selectedPeriodIndex === 0;
        // @ts-ignore
        const isDisabledDateRange = (dateFilterStatus - ONE_DAYS_IN_UTC_FORMAT) <= 0;
        return isInFirstPeriod && isDisabledDateRange;
    }, [dateFilterStatus, selectedPeriodIndex]);
    return isDisabledDateSelected;
};
